import {EditorConfig} from 'ckeditor5-extra-build'
import {CustomUploadAdapterPlugin} from './custom-upload-adapter'

export const customConfig = {
  extraPlugins: [CustomUploadAdapterPlugin],
  link: {
    addTargetToExternalLinks: true,
    // prefix links without protocol with `http://`
    defaultProtocol: 'http://'
  }
} as EditorConfig
